import React from 'react';

export default class TimelineResumePersonalInformation extends React.Component {
    render() {
        return <div data-v-2568b4c2="" className="section">
            <div data-v-2568b4c2="" className="section-left">
                { this.props.data.name && <div data-v-2568b4c2="" className="section-name">{this.props.data.name}</div>}
                { this.props.data.profession && <div data-v-2568b4c2="" className="section-title">{this.props.data.profession}</div>}
            </div>
            <div data-v-2568b4c2="" className="section-right">
                { this.props.data.website && <div data-v-2568b4c2="" className="section-contact">{this.props.data.website}</div>}
                { this.props.data.address && <div data-v-2568b4c2="" className="section-contact">{this.props.data.address}</div>}
                { this.props.data.email && <div data-v-2568b4c2="" className="section-contact">{ this.props.data.email }</div>}
                { this.props.data.phone && <div data-v-2568b4c2="" className="section-contact">{ this.props.data.phone }</div>}
            </div>
        </div>
    }
}